import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class QuestionaryService {
  private api = inject(ApiService);

  getQuestionaryResultByMemberId(id: number) { return this.api.get(`/questionary/result/${id}`); }
  getQuestionaryResultByStudioId(id: number, start: string, end: string) {
    return this.api.get(`/questionary/summary/${id}/${start}/${end}`);
  }
}
